// Leesona 861 Wax Winder
import React from "react";
import {
   BeginBackPressureRow, CommonRows, GearCRow, GearDRow, GearERow, GearFRow,
   InputRangeRow, MinMaxRow, RunTimeRow, YardsRow
} from "./index";

export default function Machine861Wax() {
   return (
      <>
         <RunTimeRow />
         <BeginBackPressureRow />
         <GearCRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearDRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearERow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearFRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <InputRangeRow
            titleProp={"Counter FC71"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={99}
            propertyNameProp={"counterFC71"}
            errorDialogueProp={"1-99 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Counter FC72"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={99}
            propertyNameProp={"counterFC72"}
            errorDialogueProp={"1-99 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Wax Temp"}
            descriptionProp={"F"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={100}
            maxProp={300}
            propertyNameProp={"waxTemp"}
            errorDialogueProp={"100-300 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Wiper Weights"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={9999999}
            propertyNameProp={"wiperWeights"}
            errorDialogueProp={"1-9,999,999 only"}
            floatProp={false}
         />
         <YardsRow />
         <MinMaxRow
            titleProp={"Wind Ratio"}
            descriptionProp=""
            minProp1={1.0}
            maxProp1={12.99999}
            floatProp1={true}
            errorProp1={"1-12.99999 only"}
            minProp2={1.0}
            maxProp2={12.99999}
            floatProp2={true}
            errorProp2={"1-12.99999 only"}
            valueProp1={"windRatioStart"}
            valueProp2={"windRatioEnd"}
            differentDisplayProp1={"Start:"}
            differentDisplayProp2={"End:"}
         />
         <CommonRows />
      </>
   );
}
